/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Image } from './Image'
import { ImageFromJSON, ImageFromJSONTyped, ImageToJSON } from './Image'

/**
 *
 * @export
 * @interface Category
 */
export interface Category {
  /**
   *
   * @type {string}
   * @memberof Category
   */
  name: string
  /**
   *
   * @type {Image}
   * @memberof Category
   */
  icon?: Image
  /**
   *
   * @type {number}
   * @memberof Category
   */
  order: number
}

/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): value is Category {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('order' in value) || value['order'] === undefined) return false
  return true
}

export function CategoryFromJSON(json: any): Category {
  return CategoryFromJSONTyped(json, false)
}

export function CategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Category {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    icon: json['icon'] == null ? undefined : ImageFromJSON(json['icon']),
    order: json['order'],
  }
}

export function CategoryToJSON(value?: Category | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    icon: ImageToJSON(value['icon']),
    order: value['order'],
  }
}
